import React from 'react';
import { Grid, useMediaQuery } from 'bonfire-kindling';

import RecommendedOpportunities from './RecommendedOpportunities';
import CommodityCodes from './CommodityCodes';
import Keywords from './Keywords';

const DashboardContent = () => {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));

  return (
    <Grid
      container
      direction={isDesktop ? 'row' : 'column'}
      spacing={{ xs: 2, md: 3 }}
      sx={{ mt: { xs: '0.1125rem' } }}
    >
      <Grid item xs sx={{ width: '100%' }}>
        <RecommendedOpportunities />
      </Grid>
      <Grid item container direction="column" xs spacing={{ xs: 2, md: 3 }}>
        <Grid item xs sx={{ minHeight: { lg: '0' } }}>
          <CommodityCodes />
        </Grid>
        <Grid item xs sx={{ minHeight: { lg: '0' } }}>
          <Keywords />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashboardContent;
